export default __webpack_public_path__ + "static/media/hubble.ce4accdf.png";